import { broadcastResponseToMainFrame } from "@azure/msal-browser/redirect-bridge";

/**
 * MSAL v5 не читает ответ Microsoft из адреса iframe (тихое продление токена) и popup: страница
 * redirectUri должна сама переслать его в главное окно. redirectUri у нас — корень приложения,
 * поэтому без этого в дочернем окне стартовало бы всё приложение: в iframe MSAL падает с
 * block_iframe_reload, а главное окно, не дождавшись ответа, — с timed_out.
 */
const isMsalChildWindow = () => {
  const inIframe = window.self !== window.top;
  const inPopup = Boolean(window.opener) && window.opener !== window;

  return inIframe || inPopup;
};

/** Ответ авторизации приходит в hash или query: code либо error вместе со state. */
const hasAuthResponseInUrl = () => {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, "") || window.location.search);

  return params.has("state") && (params.has("code") || params.has("error"));
};

/**
 * true — это дочернее окно MSAL с ответом Microsoft: ответ переслан в главное окно, само приложение
 * здесь запускать нельзя. Вызывается первым делом при старте, до рендера и до init авторизации.
 */
export const handleMsalChildWindow = (): boolean => {
  if (!isMsalChildWindow() || !hasAuthResponseInUrl()) return false;

  broadcastResponseToMainFrame().catch((error: unknown) => {
    console.error("[Auth] Failed to pass the Microsoft response to the main window", error);
  });

  return true;
};
